import * as React from "react";

import type { LogPanelState } from "@/shared/state/visualization/schema";

import { LogPanelContext } from "./LogPanelContext";

interface LogPanelProviderProps extends React.PropsWithChildren {
  /**
   * Log panel configuration state
   */
  config?: LogPanelState["config"];
}

export function LogPanelProvider({ children, config }: LogPanelProviderProps) {
  // Show search if there's a search filter or any column filters
  const [isSearchVisible, setSearchVisibility] = React.useState<boolean>(
    function initialSearchVisibility() {
      if (!config) {
        return false;
      }
      return (
        config.searchFilter !== undefined ||
        (config.columnFilters !== undefined &&
          Object.keys(config.columnFilters).length > 0)
      );
    },
  );

  const toggleSearchVisibility = () => {
    setSearchVisibility((prev) => !prev);
  };

  return (
    <LogPanelContext.Provider
      value={{
        isSearchVisible,
        toggleSearchVisibility,
      }}
    >
      {children}
    </LogPanelContext.Provider>
  );
}
